import { Component, OnInit } from '@angular/core'
import { environment } from '@employer/environments/environment'
@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
})
export class AboutComponent implements OnInit {
  employerEnv = environment
  constructor() {}

  ngOnInit(): void {}
}
